import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-branding',
  imports: [],
  template: `
    <a href="/" [class]="['logodark', class]">
      <img [src]="!isCollapsed ? './assets/images/logos/gfli-light-logo.webp' :'./assets/images/logos/gfli-mini.png'" [class]="class" class="mx-auto" alt="logo"/>
    </a>

    <a href="/" [class]="['logolight', class]">
      <img src="./assets/images/logos/gfli-dark-logo.webp" [class]="class" [class.p-8]="isCollapsed" class="mx-auto" alt="logo"/>
    </a>
  `
})
export class BrandingComponent {
  @Input() isCollapsed = false;
  @Input() class?: string;
}
